import { ITEM_DEFINITION_CODES } from './item-definitions';

// Step urls to be used outside of Mover-App for routing to mover-app
// Note: we need to deep-link into certain steps so that back button works
export const STEP_URLS = {
  STEP_AUTO_INSURANCE: '/auto-insurance',
  STEP_CUSTOM_INFORMATION: '/info/:code', // TODO: convert to regex.
  STEP_DIY_MOVE: '/diy-move',
  STEP_DMV: '/dmv',
  STEP_FORWARD_MAIL: '/forward-mail',
  STEP_FORWARD_MAIL_LIST: '/forward-mail',
  STEP_HOME_SECURITY: '/home-security',
  STEP_HOME_SERVICES: '/home-services',
  STEP_HOME_SERVICES_APP: '/tv-internet/',
  STEP_HUDSON_INSURANCE: '/shop-for-insurance',
  STEP_INSURANCE: '/insurance/',
  STEP_INSURANCE_QUOTES: '/insurance-quotes',
  STEP_INSURANCE_RETENTION: '/update-insurance',
  STEP_MOVEIQ: '/book-your-move/',
  STEP_MOVE_YOUR_STUFF: '/move-your-stuff',
  STEP_MOVING_CENTER: '/book-move',
  STEP_OFFERS: '/move-in-offers',
  STEP_PROMOTIONS: '/move-in-promotions/',
  STEP_RECOMMENDED_PROVIDERS: '/recommended-providers',
  STEP_RELOCATION_SPECIALISTS: '/full-service-move/current-home',
  STEP_PACKING_SUPPLIES: '/packing-supplies/moving-kits',
  STEP_RED_CROSS: '/red-cross',
  STEP_RENTERS_INSURANCE: '/renters-insurance',
  STEP_RESIDENT_PORTAL: '/resident-portal',
  STEP_SHARE_MOVE: '/moving-announcement',
  STEP_SMART_HOME_OWN: '/smart-home',
  STEP_UPDATE_ACCOUNTS: '/update-accounts',
  STEP_UTILITIES: '/utilities',
  STEP_CALIFORNIA_CARE: '/california-care',
  STEP_BACKUP_GENERATOR: '/backup-generator',
  STEP_DUKE_WARRANTY: '/duke-warranty',
};

export const ITEM_DEFINITION_URLS = {
  AUTO_INSURANCE: STEP_URLS.STEP_AUTO_INSURANCE,
  DIY_MOVE: STEP_URLS.STEP_DIY_MOVE,
  DMV: STEP_URLS.STEP_DMV,
  FORWARD_MAIL: STEP_URLS.STEP_FORWARD_MAIL_LIST, // Deeplink to avoid back-button redirect
  HOME_SECURITY: STEP_URLS.STEP_HOME_SECURITY,
  HOME_SERVICE: STEP_URLS.STEP_HOME_SERVICES,
  HOME_SERVICE_APP: STEP_URLS.STEP_HOME_SERVICES_APP,
  HUDSON_INSURANCE: STEP_URLS.STEP_HUDSON_INSURANCE,
  INFORMATION: STEP_URLS.STEP_CUSTOM_INFORMATION,
  INSURANCE: STEP_URLS.STEP_INSURANCE,
  INSURANCE_QUOTE: STEP_URLS.STEP_INSURANCE_QUOTES,
  INSURANCE_RETENTION: STEP_URLS.STEP_INSURANCE_RETENTION,
  MOVEIQ: STEP_URLS.STEP_MOVEIQ,
  MOVING_CENTER: STEP_URLS.STEP_MOVING_CENTER,
  OFFER: STEP_URLS.STEP_OFFERS,
  PROMOTION: STEP_URLS.STEP_PROMOTIONS,
  RECOMMENDED_PROVIDER: STEP_URLS.STEP_RECOMMENDED_PROVIDERS,
  RED_CROSS: STEP_URLS.STEP_RED_CROSS,
  RENTERS_INSURANCE: STEP_URLS.STEP_RENTERS_INSURANCE,
  RESIDENT_PORTAL: STEP_URLS.STEP_RESIDENT_PORTAL,
  SHARE: STEP_URLS.STEP_SHARE_MOVE,
  SMART_HOME_OWN: STEP_URLS.STEP_SMART_HOME_OWN,
  UPDATE_ACCOUNT: STEP_URLS.STEP_UPDATE_ACCOUNTS,
  UTILITY: STEP_URLS.STEP_UTILITIES,
  CALIFORNIA_CARE: STEP_URLS.STEP_CALIFORNIA_CARE,
  BACKUP_GENERATOR: STEP_URLS.STEP_BACKUP_GENERATOR,
  DUKE_WARRANTY: STEP_URLS.STEP_DUKE_WARRANTY,
};

export const ITEM_DEFINITION_CODES_TO_URLS = Object.keys(
  ITEM_DEFINITION_CODES
).reduce(
  (obj, key) => ({
    ...obj,
    ...{ [ITEM_DEFINITION_CODES[key]]: ITEM_DEFINITION_URLS[key] },
  }),
  {}
);
